import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import Home from './components/Home/Home';
import NotFound from './components/NotFound/NotFound';
import Header from './components/Header/Header';
import TeamDetail from './components/TeamDetail/TeamDetail';
import BannerImage from './components/BannerImage/BannerImage';
import Footer from './components/Footer/Footer';
import About from './components/About/About';

function App() {
  return (
    <div className='main-container'>
      <div className="">
        <Router>
          <Switch>
            <Route exact path="/">
              <Header />
              <BannerImage />
              <Home />
              <Footer />
            </Route>
            <Route path="/home">
              <Header />
              <BannerImage />
              <Home />
              <Footer />
            </Route>
            <Route path='/team/:idTeam'>
              <Header />
              <TeamDetail />
              <Footer />
            </Route>
            <Route path="/about">
              <Header />
              <BannerImage />
              <About />
              <Footer />
            </Route>
            <Route path="*">
              <Header />
              <BannerImage />
              <NotFound />
              <Footer />
            </Route>
          </Switch>
        </Router>
      </div>
    </div>
  );
}

export default App;
